<template>
  <loader v-if="loadingProducts" />
  <div v-else>
    <tyres-products-block
      v-if="visible"
      :data-qa="`${quoteNamespace}_tyres-accessories`"
      :products="products"
      :products-categories="categories"
      :selected-products="selectedTyresProducts"
      :products-are-editable="false"
      :show-selected-products="true"
      :show-buttons="false"
      :is-tyres-products="true"
      block-type="DealerAccessories"
    />
    <modal
      v-if="visible && showListModal"
      :title="i18n.t('/productblocks/tyresaccessories/selectallseasonbutton')"
      @close="toggleListModal(false)"
    >
      <tyres-products-block
        :data-qa="`${quoteNamespace}_tyres-accessories_popup`"
        :products="products"
        :products-categories="categories"
        :selected-products="selectedProducts"
        :products-are-editable="isEditable"
        :show-selected-products="true"
        :is-tyres-products="true"
        block-type="DealerAccessories"
        @add-to-selected="addTyresToSelected"
        @remove-from-selected="removeTyresFromSelected"
        @mark-product-as-tyres="markProductAsTyres"
      />
    </modal>
    <app-button
      v-if="visible"
      :disabled="disabled"
      data-qa="select-season-tyres-button"
      @click="toggleListModal(true)"
      >{{ i18n.t('/productblocks/tyresaccessories/selectallseasonbutton') }}
    </app-button>
  </div>
</template>

<script>
import TyresProductsBlock from '@/components/generic/presentational/organisms/productsBlock/TyresProductsBlock.vue'
import HandleAccessoryEvents from '@/mixins/handleAccessoryEvents.js'
import AdditionalOrder from '@/mixins/additionalOrder.js'
import Loader from '@/components/generic/presentational/atoms/loader/Loader.vue'
import AppButton from '@/components/generic/presentational/atoms/appButton/AppButton.vue'
import Modal from '@/components/generic/presentational/molecules/modal/Modal.vue'
import { mapState } from 'vuex'

export default {
  components: {
    TyresProductsBlock,
    Loader,
    AppButton,
    Modal,
  },
  mixins: [HandleAccessoryEvents, AdditionalOrder],
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
      categories: ['DealerAccessories'],
      showListModal: false,
    }
  },
  computed: {
    // Dynamic namespaces aren't supported by mapGetters
    ...mapState({
      state(state) {
        return state[this.quoteNamespace]
      },
      quoteAccessoriesWithCategories(state, getters) {
        return getters[this.quoteNamespace + '/accessoriesWithCategories']
      },
      isEditable(state, getters) {
        return !getters[this.quoteNamespace + '/quoteStatusIsSalesOrder']
      },
      loadingProducts(state, getters) {
        return getters['accessories/loading']
      },
      accessoriesWithCategories(state, getters) {
        return getters['accessories/accessoriesWithCategories']
      },
    }),
    allSeasonTyresAdded() {
      return this.selectedProducts.some((product) => product.AllWeatherTyresPL === true)
    },
    selectedProducts() {
      return this.quoteAccessoriesWithCategories(this.categories)
    },
    selectedTyresProducts() {
      return this.selectedProducts.filter((product) => product.AllWeatherTyresPL === true)
    },
    products() {
      if (this.additionalQuote) {
        const parentQuoteAccessories =
          this.$store.getters['quote/accessoriesWithCategories'](this.categories)?.map(
            (x) => x.ID
          ) || []
        return this.accessoriesWithCategories(this.categories).filter(
          (x) => !parentQuoteAccessories.includes(x.ID)
        )
      }
      return this.accessoriesWithCategories(this.categories)
    },
  },
  methods: {
    addTyresToSelected(selectedProduct) {
      this.resetAllWeatherTyresPL(false)
      selectedProduct.AllWeatherTyresPL = true
      this.addToSelected(selectedProduct)
      this.toggleListModal(false)
    },
    removeTyresFromSelected(deselectedProduct) {
      this.resetAllWeatherTyresPL(false)
      deselectedProduct.AllWeatherTyresPL = false
      this.removeFromSelected(deselectedProduct)
    },
    markProductAsTyres(selectedProduct) {
      let newValue = !selectedProduct.AllWeatherTyresPL
      this.resetAllWeatherTyresPL(false)
      selectedProduct.AllWeatherTyresPL = newValue
      this.modifyAccessory(selectedProduct)
      if (newValue) {
        this.toggleListModal(false)
      }
    },
    checkOpenEditModal() {
      if (!this.allSeasonTyresAdded) {
        this.toggleListModal(true)
      }
    },
    toggleListModal(show) {
      this.showListModal = show
    },
  },
}
</script>
